import HsIndividualResourceMetadata from './component'
export default HsIndividualResourceMetadata
